import { diYu } from '../constant/common-var'

export default {
  data: function() {
    return {
      heads: [
        { label: '长期意向', options: ['Y', 'N', 'F'], editType: 'select' },
        { label: '姓名' },
        { label: '英文名' },
        { label: '曾任职公司' },
        { label: '公司' },
        { label: '部门' },
        { label: '组别' },
        { label: '目前职位' },
        { label: '手机' },
        { label: '其他' },
        { label: '座机' },
        { label: '邮箱' },
        { label: '地域', options: diYu, editType: 'createSelect' },
        { label: '性别', options: ['男', '女'], editType: 'select' },
        { label: '规模' },
        { label: '管理基金数量' },
        { label: '管理基金' },
        { label: '任职期' },
        { label: '行业', options: app.industries || [], editType: 'select' },
        { label: '职能模块', editType: 'multSelect' },
        { label: '细分职能', editType: 'multSelect' },
        { label: '平台', options: ['A', 'B', 'C'], editType: 'select' },
        { label: '职级', options: ['1', '2', '3', '4', '5'], editType: 'select' },
        { label: '业绩', options: ['aaa', 'aa', 'a', 'b', 'c', 'd'], editType: 'select' },
        { label: '擅长方向', editType: 'multSelect' },
        { label: '建议业绩' },
        { label: '投资风格' },
        { label: '个性标签' },
        {
          label: '学历标签',
          options: [
            '常青藤',
            '清北交复',
            '985',
            '211',
            '海外背景',
            'QS100',
            'TIMES100',
            '理工科',
            '财务',
            '法务',
            '金融',
            '医药医疗',
            '微电子',
            '计算机',
            '中金line',
            '中信line',
            '建投line',
            '广发学历',
            '前海开源line',
          ],
          editType: 'multSelect',
        },
        {
          label: '语言标签',
          options: [
            '英文-1-母语水平',
            '英文-2-工作语言',
            '英文-3-可顺利读写，口语较弱',
            '粤语',
            '日语',
            '法语',
            '小语种',
          ],
          editType: 'multSelect',
        },
        { label: '旧系统沟通备注', width: 120 },
        { label: '沟通日志', width: 120 },
        { label: '管理职级', editType: 'input' },
        { label: '专业职级', editType: 'input' },
        { label: '下属个数' },
        { label: '汇报上级' },
        { label: '奖金' },
        { label: '期望行业', options: app.industries || [], editType: 'select' },
        { label: '期望地域', options: diYu, editType: 'createSelect' },
        { label: '期望固薪' },
        { label: '期望奖金' },
        { label: '简介' },
        { label: '婚育' },
        { label: '出生年月' },
        { label: '籍贯' },
        { label: '学历' },
        { label: '本科院校' },
        { label: '硕士院校' },
        { label: '到现公司时间' },
        { label: '从业起始年' },
        { label: '微信' },
      ],
    }
  },
}
